import React, { useState } from 'react';
import { find, get, getApi, hasFunctionQixinSearch } from '~/utils';
import { API, EMPTY_FN } from '~/constants';
import { SearchList } from '~/components';

interface IQiXinCorpSearchProps {
    className?: string;
    placeholder?: string;
    inputRef: any;
    corpName: string;
    onInstantChange?: (v: string) => void; // 输入框值即时变化
    onChange: (v: string) => void; // 输入框值变化
    onSelectCorp: (blur: boolean, v?: Record<string, any>) => void; // 选择企业/重置企业/失焦匹配企业
    maxLength?: number;
    errMsg?: string;
    autoSelect?: boolean;
    onBlur?: () => void;
}

/**
 * 启信宝工商信息搜索
 * @param props
 * @constructor
 */
const QiXinCorpSearch: React.FC<IQiXinCorpSearchProps> = (props) => {
    const {
        placeholder,
        className,
        corpName,
        onInstantChange = EMPTY_FN,
        onChange,
        onSelectCorp,
        inputRef,
        maxLength,
        autoSelect,
        errMsg,
        onBlur
    } = props;
    const [items, setItems] = useState<any[]>([]);

    return (
        <SearchList
            maxLength={maxLength}
            errMsg={errMsg}
            placeholder={placeholder}
            className={className}
            ref={inputRef}
            value={corpName}
            items={items}
            normalInputStyle
            showSearchResult={hasFunctionQixinSearch()}
            keyMatchOnly={false}
            debounceTime={1500}
            async={{
                url: getApi(API.conf.search_corp),
                data: {
                    matchType: ['ename', 'product', 'copyright', 'software', 'trademark']
                },
                config: {
                    customHandleErrorFn: () => {
                        return true;
                    }
                }
            }}
            onAsyncSuccess={(res) => {
                const corps = get(res, 'data.corps', []);
                setItems(corps);
                onSelectCorp(false);
            }}
            onAsyncError={() => {
                setItems([]);
                onSelectCorp(false);
            }}
            onItemClick={(item) => {
                onSelectCorp(false, item);
            }}
            onReturn={(item) => {
                onSelectCorp(false, item);
            }}
            onInputInstantChange={(v) => {
                onInstantChange(v);
            }}
            onInputChange={(v) => {
                onChange(v);
            }}
            onPopupVisibleChange={(visible) => {
                // 失焦时若有企业名称与keyword一致且当前无选中企业,选择该企业
                if (!visible) {
                    const exactlySameItem = find(items, (v) => {
                        return v.name === corpName;
                    });
                    if (exactlySameItem) {
                        onSelectCorp(true, exactlySameItem);
                    }
                }
            }}
            autoSelect={autoSelect}
            onBlur={onBlur}
        />
    );
};
export default QiXinCorpSearch;
